import React, { Component } from "react"
import Input from "../input/Input"
import ButtonV2 from "../button-v2"
import SbEditable from "storyblok-react"
import queryString from "query-string"
import Cookies from "js-cookie"
import { unified } from "unified"
import Components from "../index"
import remarkParse from "remark-parse"
import remarkRehype from "remark-rehype"
import rehypeReact from "rehype-react"
import linkHandler from "../../helpers/storyblokLinkHandler"
import remarkReactComponents from "../../helpers/remarkReactComponents"
import { addCookieData } from "../../helpers/handleCookies"

function cleanData(data) {
  if (!data) return ""

  if (Array.isArray(data)) return data[0]

  return data
}

class StudentApp extends Component {
  constructor() {
    super()
    this.handleResize = this.handleResize.bind(this)
  }
  state = {
    email: "",
    isValid: undefined,
    buttonWidth: 136,
    program: "",
    contact: {},
  }

  componentDidMount = () => {
    window.addEventListener("resize", this.handleResize)
    let buttonWidth = document.getElementsByClassName(
      "student-app__form-button"
    )[0].clientWidth
    this.setState({
      buttonWidth: buttonWidth,
      program: this.props.blok.program,
    })

    if (typeof window !== "undefined") {
      const queryParams = queryString.parse(window.location.search)
      const contactId = queryParams.S

      if (contactId) {
        fetch(
          `${process.env.GATSBY_SALESFORCE_API}/hulthousing/services/apexrest/GetContactInfo`,
          {
            method: "post",
            body: JSON.stringify({ contactID: contactId }),
          }
        )
          .then((resp) => {
            return resp.json()
          })
          .then((data) => {
            this.setState({
              contact: JSON.parse(data),
              email: JSON.parse(data).Email,
              isValid: true,
            })
          })
      } else {
        this.setState({
          contact: {},
        })
      }
    }
  }

  handleResize() {
    let resizedButtonWidth = document.getElementsByClassName(
      "student-app__form-button"
    )[0].clientWidth
    this.setState({
      buttonWidth: resizedButtonWidth,
    })
  }

  handleChange = (e) => {
    const validCheck =
      e.target.checkValidity() || typeof this.state.isValid !== "undefined"
        ? e.target.checkValidity()
        : undefined
    this.setState({ isValid: validCheck, email: e.target.value })
  }

  handleSubmit = () => {
    if (!this.state.email || !this.state.isValid)
      return this.setState({ isValid: false })

    const country = this.state.contact?.CountryCode
      ? this.state.contact?.CountryCode
      : cleanData(Cookies.get("uCountry"))

    // If program then set cookie
    if (this.state.program) {
      Cookies.set("program", this.state.program, { domain: "hult.edu" })
    }

    // Set expiry of cookie to 5 minutes time
    const fiveMinuteExpiry = new Date()
    fiveMinuteExpiry.setTime(fiveMinuteExpiry.getTime() + 1 * 1 * 5 * 60 * 1000)
    Cookies.set("azr_enly", btoa(this.state.email), {
      expires: fiveMinuteExpiry,
      domain: "hult.edu",
    })
    Cookies.set("oSignUp", true, {
      expires: fiveMinuteExpiry,
      domain: "hult.edu",
    })

    window.dataLayer.push({
      event: "stdapp_getCode",
      eventMeta: {
        content: this.state.program,
        timestamp: JSON.stringify(new Date()),
      },
    })

    window.location.href = process.env.GATSBY_STUDENT_APP_URL
  }

  render() {
    const { blok } = this.props

    return (
      <SbEditable content={blok}>
        <div className={`student-app ${this.props.className}`}>
          {blok.deadline &&
            blok.deadline.map(
              (content) =>
                React.createElement(Components(content.component), {
                  key: content._uid,
                  blok: content,
                  className: "student-app__deadline",
                })
            )}
          {blok.title && (
            <h2 className="student-app__title heading heading--accent">
              {blok.title}
            </h2>
          )}
          {blok.copy && (
            <div className="student-app__copy">
              {
                unified()
                  .use(remarkParse)
                  .use(remarkRehype)
                  .use(rehypeReact, {
                    createElement: React.createElement,
                    components: remarkReactComponents,
                    Fragment: React.Fragment
                  })
                  .processSync(blok.copy).result
              }
            </div>
          )}
          <div
            className="student-app__form"
            style={{
              paddingRight: "calc(" + this.state.buttonWidth + "px - 2.2rem)",
            }}
          >
            <Input
              className="student-app__form-input form-control--v2"
              label="Email"
              type="email"
              placeholder={blok.input_placeholder}
              value={this.state.email}
              onChange={this.handleChange}
              isValid={this.state.isValid}
              required
            />
            <ButtonV2
              className="student-app__form-button button-v2--primary"
              label={blok.button_label}
              icon={blok.button_icon}
              onClick={this.handleSubmit}
            />
          </div>
          {blok.continue_label && (
            <div className="student-app__continue">
              <p>
                <a href={linkHandler(blok.continue_url)}>
                  Already started an application?
                </a>
              </p>
            </div>
          )}
        </div>
      </SbEditable>
    )
  }
}

export default StudentApp
